import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SUPABASE, XANO, ZAPIER, REST_API } from 'drapcode-constant';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { snakeCaseToTitleCase } from '../../common/utils/api_utils';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import showAlert, { showAlertHtml } from '../../common/utils/alert';
import CustomLoader from '../common/CustomLoader';
import ParentContentCard from '../common/ParentContentCard';
import { externalApisTableHeaders } from '../../common/utils/headers';
import ExternalApiTable from './ExternalApiTable';
import TooltipInfo from '../../common/docs/TooltipInfo';
import PermissionDenied from '../../common/PermissionDenied';
import { inUseTooltip } from '../../common/utils/validate';

class ExternalApiList extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { page: 0, limit: 25, searchTerm: '' };

  componentDidMount = () => {
    const { projectId, actions, activeTab, externalapi, version } = this.props;
    const { loadExternalApisPending } = externalapi;
    if (!loadExternalApisPending) {
      actions.loadExternalApis({
        projectId,
        page: this.state.page,
        version,
        limit: this.state.limit,
        externalApiType: activeTab,
      });
    }
    actions.loadProjectDetail({ projectId, version });
  };
  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    const { activeTab: nextActiveTab, projectId, actions, externalapi, version } = nextProps;
    const { activeTab } = this.props;
    const { loadExternalApisPending } = externalapi;
    if (nextActiveTab !== activeTab) {
      if (!loadExternalApisPending) {
        actions.loadExternalApis({
          projectId,
          version,
          page: this.state.page,
          limit: this.state.limit,
          externalApiType: nextActiveTab,
        });
      }
    }
    return true;
  };
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  handleDelete = (uuid) => {
    const { projectId, actions, version } = this.props;
    const text = "You won't be able to revert this.";
    const preConfirm = () => {
      actions.deleteExternalApi({ uuid, projectId, version });
    };
    const confirmButtonText = 'Yes, delete it!';
    showAlert(text, preConfirm, confirmButtonText);
  };

  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };
  handleClone = (externalapi) => {
    const { projectId, actions, version } = this.props;
    const {
      externalApiName,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    } = externalapi;
    const data = {
      externalApiName,
      projectId,
      version,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    };

    const text = `Do you want to clone <b>${externalApiName}</b> REST API?`;
    const preConfirm = () => {
      actions.cloneExternalApi(data).then(() => {
        actions.loadExternalApis({
          projectId,
          version,
          page: this.state.page,
          limit: this.state.limit,
          externalApiType: this.props.activeTab,
        });
      });
    };
    const confirmButtonText = 'Yes, Clone it!';
    showAlertHtml(text, preConfirm, confirmButtonText, 'warning', '#93a828');
  };
  handleSearch = () => {
    const { projectId, actions, activeTab, externalapi, version } = this.props;
    const { page, limit, searchTerm } = this.state;
    const { loadExternalApisPending } = externalapi;
    if (!loadExternalApisPending) {
      actions.loadExternalApis({
        projectId,
        page,
        limit,
        version,
        searchTerm,
        externalApiType: activeTab,
      });
    }
  };
  onPageChange = (val) => {
    const { projectId, actions, activeTab, externalapi, version } = this.props;
    const { limit, searchTerm } = this.state;
    const { loadExternalApisPending } = externalapi;
    if (!loadExternalApisPending) {
      actions.loadExternalApis({
        projectId,
        version,
        page: val.selected,
        limit,
        externalApiType: activeTab,
        searchTerm,
      });
    }
    this.setState({ page: val.selected });
  };

  getCollectionTitle = (collectionName) => {
    const { collections } = this.props.externalapi;
    const collection = collections.find((e) => e.collectionName === collectionName);
    return collection ? collection.collectionTitle : collectionName;
  };

  showExternalApisList = () => {
    const { externalApis, deleteExternalApiPending, totalExternalApisPages, collections } =
      this.props.externalapi;
    const { projectId, activeTab, version, flag } = this.props;
    const description = `<ul style="padding-left:1rem"><li><strong>Request collection</strong> is mapped with Request Body Mapping of External API. Colour marked with <em>Light blue</em> badge .</li><li><strong>Response collection</strong> is mapped with the Response Data Mapping of External API. Colour marked with <em>Dark blue</em> badge.</li></ul>`;
    if (externalApis && externalApis.length > 0) {
      return (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-sm table-word-break connector-list">
              <thead>
                <tr>
                  {externalApisTableHeaders.map((tableHeader) => (
                    <th key={tableHeader}>
                      {tableHeader}
                      {tableHeader === 'Collection' && (
                        <>
                          &nbsp;
                          <TooltipInfo
                            title={description}
                            headerText={`What's Collection?`}
                            showHeader={true}
                            showArrow={true}
                          />
                        </>
                      )}
                      {tableHeader === 'In Use' && (
                        <>
                          &nbsp;
                          <TooltipInfo
                            title={inUseTooltip('external api')}
                            headerText={`What's In Use?`}
                            showHeader={true}
                            showArrow={true}
                          />
                        </>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {externalApis.map((externalapi) => (
                  <ExternalApiTable
                    projectId={projectId}
                    version={version}
                    key={externalapi.uuid}
                    externalapi={externalapi}
                    collections={collections}
                    deleteExternalApiPending={deleteExternalApiPending}
                    handleDelete={this.handleDelete}
                    handleClone={this.handleClone}
                    flag={flag}
                  />
                ))}
              </tbody>
            </table>
          </div>
          {totalExternalApisPages > 1 && (
            <CustomReactPaginate
              totalPages={totalExternalApisPages}
              pageRangeDisplayed={10}
              marginPagesDisplayed={2}
              page={this.state.page}
              onPageChange={this.onPageChange}
            />
          )}
        </>
      );
    } else
      return (
        <div className="alert">
          No {activeTab === REST_API ? 'REST API' : snakeCaseToTitleCase(activeTab)} found! Please
          create one if needed.
        </div>
      );
  };

  render() {
    const { externalapi, projectId, activeTab, version } = this.props;
    const { loadExternalApisPending } = externalapi;

    const title = activeTab === REST_API ? 'REST API' : snakeCaseToTitleCase(activeTab);
    let headerLink = null;
    if (activeTab === REST_API) {
      headerLink = {
        pathname: `/externalapi/${version}/v/${projectId}/create`,
        state: { activeTab },
      };
    }
    return (
      <ParentContentCard
        isSearch={true}
        updateSearchTerm={this.updateSearchTerm}
        handleSearch={this.handleSearch}
        color="drapcode-violet"
        icon={activeTab === REST_API ? 'REST_API' : ''}
        title={title}
        headerLink={headerLink}
        headerTitle="Create External API"
        headerText=" Create External API"
        datasourceIconSvg={activeTab === REST_API ? '' : activeTab}
      >
        {loadExternalApisPending ? (
          <div className="text-center">
            <CustomLoader loading={loadExternalApisPending} size="20px" color="#303453" />
          </div>
        ) : (
          this.showExternalApisList()
        )}
      </ParentContentCard>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalApiList);
